<nb-card>
    <nb-card-header>Neues Passwort</nb-card-header>
    <nb-card-body>
        <p>Das folgende Passwort wurde generiert: {{password}}</p>
    </nb-card-body>
    <nb-card-footer>
        <button nbButton hero class="mat-ripple appearance-filled size-medium status-basic shape-rectangle ng-star-inserted nb-transition" (click)="copy()">in Zwischenablage kopieren</button>
        <button nbButton hero class="mat-ripple appearance-filled size-medium status-basic shape-rectangle ng-star-inserted nb-transition" (click)="dismiss()">Schlie&szlig;en</button>
    </nb-card-footer>
</nb-card>